import React, { useEffect, useState, useCallback, useMemo } from "react";
import ListMenu from "./ListMenu/ListMenu";
import "./List.css";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Filter from "./Filter/Filter";
import Loading from "../../../../Utils/Loading/Loading";
import NotFound from "../../../../Utils/NotFound/NotFound";
import ListCard from "./ListCard";

const backend = await new Backend().init();

export default function Bank({ master_id, userType }) {
  const windowSize = useSize();
  const [loading, setLoading] = useState(false);
  const [account, setAccount] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  // 🔹 Memoized base object
  const base = useMemo(
    () => ({
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
    }),
    []
  );

  // 🔹 Load Accounts
  const loadAccount = useCallback(async () => {
    setLoading(true);

    const data =
      userType === 5
        ? { ...base, broker_id: localStorage.getItem("id") }
        : userType === 3
        ? { ...base, master_id: localStorage.getItem("id") }
        : userType === 2
        ? master_id
          ? { ...base, master_id }
          : { ...base, super_id: localStorage.getItem("id") }
        : master_id
        ? { ...base, master_id }
        : { ...base, admin_id: localStorage.getItem("id") };

    try {
      const res = await backend.load_bank_account(data);

      if (res.error === "False") {
        const accounts = res.account || [];
        setAccount(accounts);
        setFilteredUsers(accounts); // ✅ IMPORTANT FIX
      } else if (res.logout === 1) {
        window.LogOut?.();
      } else {
        toast.error(res.message || "Failed to load accounts");
      }
    } catch (error) {
      console.error("Error loading accounts:", error);
      toast.error("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, [base, master_id, userType]);

  // 🔁 Initial load
  useEffect(() => {
    loadAccount();
    window.loadAccount = loadAccount;
  }, [loadAccount]);

  // 🔍 Search handler
  const search = useCallback(
    (value) => {
      if (!value || value.trim().length < 2) {
        setFilteredUsers(account);
        return;
      }

      const v = value.toLowerCase();

      const filtered = account.filter((u) =>
        u.account_number?.toLowerCase().includes(v)
      );

      setFilteredUsers(filtered);
    },
    [account]
  );

  // 🖥️ UI
  return (
    <div style={{ height: windowSize[1] - 160, width: windowSize[0] }}>
      <Filter
        records={filteredUsers.length}
        search={search}
      />

      <ListMenu userType={userType} />

      <div
        style={{
          width: windowSize[0],
          height: windowSize[1] - 220,
          overflowY: "auto",
        }}
      >
        {loading ? (
          <div className="loadingContainer">
            <Loading height={windowSize[1] - 220} />
          </div>
        ) : filteredUsers.length > 0 ? (
          filteredUsers.map((item, index) => (
            <ListCard
              key={item.id || index}
              userType={userType}
              item={item}
              index={index}
              reload={loadAccount}
            />
          ))
        ) : (
          <NotFound
            height={windowSize[1] - 220}
            title="Nothing here"
            subtext="No Account Found. Use Filter."
          />
        )}
      </div>
    </div>
  );
}